import { ClassRoomType } from "../../gql/graphql.ts";
import { TeacherClassRoomRecord } from "./teacherClassRoomRecord.ts";
import { shareOf } from "./shareOf.ts";

export type FeedbackCompletion = {
  expectedFeedbacks: number;
  filledFeedbacks: number;
  classRoomsMissingFeedback: number;
  completionRate: number | null;
};

function filledFeedbacksOf(classRoom: TeacherClassRoomRecord): number {
  const writtenFeedbacks =
    classRoom.type === ClassRoomType.Exam
      ? classRoom.progressCheckResultCount
      : classRoom.lessonFeedbackCount;
  return Math.min(writtenFeedbacks ?? 0, classRoom.userIds.length);
}

export function feedbackCompletion(
  taughtClassRooms: TeacherClassRoomRecord[],
): FeedbackCompletion {
  const expectedFeedbacks = taughtClassRooms.reduce(
    (total, classRoom) => total + classRoom.userIds.length,
    0,
  );
  const filledFeedbacks = taughtClassRooms.reduce(
    (total, classRoom) => total + filledFeedbacksOf(classRoom),
    0,
  );
  const classRoomsMissingFeedback = taughtClassRooms.filter(
    (classRoom) => filledFeedbacksOf(classRoom) < classRoom.userIds.length,
  ).length;
  return {
    expectedFeedbacks,
    filledFeedbacks,
    classRoomsMissingFeedback,
    completionRate: shareOf(filledFeedbacks, expectedFeedbacks),
  };
}
